import $ from 'jquery';

/**
 * @desc Fixes inconsistent behavior among browsers when clicking on buttons.
 * Browsers are inconsistent in how they handle a click on <button>.
 * Some browsers choose to focus on the button (Win FF, Win/Mac Chrome, Edge).
 * Some browsers don’t (Safari, Mac FF).
 * @see {@link https://zellwk.com/blog/inconsistent-button-behavior/}
 */
export default class MCConsistentFocus {
  constructor() {
    MCConsistentFocus.makeConsistent();
  }

  static makeConsistent() {
    $(document).click((event) => ($(event.target).is(':button') ? event.target.focus() : undefined));
  }
}
